import React from 'react';
import PropTypes from 'prop-types';
import './PlayheadMarker.css';

const PlayheadMarker = ({ markerPositionPx, formatTime, currentTime, onMouseDown }) => {
  return (
    <button
      className="playhead-marker"
      style={{
        left: `calc(${markerPositionPx}px + 12.5vh)`,
        border: "none",
        padding: 0,
        backgroundColor: "transparent"
      }}
      onMouseDown={onMouseDown}
      aria-label="Playhead marker"
    >
      <div className="playhead-hit-area" />
      
      <div className="playhead-line" />
      
      <svg
        className="playhead-handle"
        viewBox="0 0 24 16"
        fill="none"
      >
        <path
          d="M2 0 C2 0, 0 0, 0 2 L12 16 L24 2 C24 0, 22 0, 22 0 L2 0 Z"
          fill="#60A5FA"
        />
      </svg>
      
      <div className="playhead-center" />
      
      <div className="playhead-tooltip">
        <p className="playhead-time-text">
          {formatTime(currentTime)}
        </p>
        <div className="playhead-tooltip-arrow"></div>
      </div>
    </button>
  );
};

PlayheadMarker.propTypes = {
  markerPositionPx: PropTypes.number.isRequired,
  formatTime: PropTypes.func.isRequired,
  currentTime: PropTypes.number.isRequired,
  onMouseDown: PropTypes.func.isRequired,
};

export default PlayheadMarker;
